const BASE = ['comments'];

export const COMMENT_QUERY_KEYS = {
  getComment: (id) => [...BASE, id] as const,
};
